export default __webpack_public_path__ + "static/media/90.09fcc69c.png";